import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

import type { AccountSignalTypeEntry } from "../../hooks/useAccountSignalsPageTypes";
import { AccountSignalTypeCard } from "../AccountSignalTypeCard/AccountSignalTypeCard";
import { StyledAccountSignalTypeCardsGrid } from "../AccountSignalTypeCard/styles";

type AccountSignalTypeCardsProps = {
    displayTypes: readonly AccountSignalTypeEntry[];
    signalsCountPerType?: Readonly<Partial<Record<SignalType, number>>>;
    isSignalsCountLoading?: boolean;
    onSignalTypeClick?: (signalType: SignalType) => void;
};

export const AccountSignalTypeCards = ({
    displayTypes,
    signalsCountPerType,
    isSignalsCountLoading = false,
    onSignalTypeClick,
}: AccountSignalTypeCardsProps) => {
    const { translate } = useTranslate();

    return (
        <StyledAccountSignalTypeCardsGrid data-automation="account-signals-list-per-type">
            {displayTypes.map((item) => (
                <AccountSignalTypeCard
                    key={item.type}
                    title={translate(signalsI18nKeys.signalType(item.type))}
                    icon={
                        <SWReactIcons
                            iconName={item.icon}
                            iconColor={colorsPalettes.carbon[300]}
                            size="xs"
                        />
                    }
                    count={
                        item.isComingSoon || isSignalsCountLoading
                            ? undefined
                            : (signalsCountPerType?.[item.type] ?? 0)
                    }
                    isCountLoading={!item.isComingSoon && isSignalsCountLoading}
                    isComingSoon={item.isComingSoon}
                    isClickable={Boolean(onSignalTypeClick)}
                    onClick={onSignalTypeClick ? () => onSignalTypeClick(item.type) : undefined}
                    dataAutomation={`account-signals-type-card-${item.type}`}
                />
            ))}
        </StyledAccountSignalTypeCardsGrid>
    );
};
